import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0b999542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-section" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-0b999542><div class=\"content\" data-v-0b999542><h1 class=\"title\" data-v-0b999542>Visión</h1><p class=\"vision\" data-v-0b999542>Thotex será líder para el 2027 ofreciendo servicios contables a pequeños y medianos comercios, siendo una plataforma fiable, de fácil uso y comprensión ayudándoles a nuestros clientes con un enfoque en la transparencia y la excelencia en el servicio.</p></div><div class=\"content\" data-v-0b999542><h1 class=\"title\" data-v-0b999542>Misión</h1><p class=\"vision\" data-v-0b999542>Ofrecer una plataforma para la gestión de nómina e inventario, en la cual pueden gestionar y automatizar procesos financieros y contables, para que nuestros usuarios tomen las mejores decisiones en sus negocios.</p></div></div>", 1)
const _hoisted_3 = { class: "team-container" }
const _hoisted_4 = { class: "team-card-image" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "team-card-content" }
const _hoisted_7 = { class: "social-links" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

  const teamMembers = [
  {
    name: 'Miguel Angel Pinzón Garcia',
    role: 'Desarrollador Frontend',
    image: 'https://i.imgur.com/dHmaI0T.jpeg',
    git: 'https://github.com/MiPinzon',
    linked: 'https://www.linkedin.com/in/miguel-angel-pinzón-garcia-1771a9267/',
  },
  {
    name: 'Juan David Vásquez Pinzon',
    role: 'Desarrollador Frontend',
    image: 'https://i.imgur.com/DBlXSqD.jpeg',
    git: 'https://github.com/juandvasquezp',
    linked: 'www.linkedin.com/in/juan-david-vasquez-pinzon',
  },
  {
    name: 'Daniel Santiago Ramírez Rocha',
    role: 'Desarrollador Backend',
    image: 'https://i.imgur.com/fa1bHTw.jpeg',
    git: 'https://github.com/Dan-code-str?tab=overview&from=2024-08-01&to=2024-08-20',
    linked: 'https://co.linkedin.com/in/daniel-santiago-ram%C3%ADrez-rocha-284621252',
  },  
];

return (_ctx: any,_cache: any) => {
  const _component_IconifyIcon = _resolveComponent("IconifyIcon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(teamMembers, (member) => {
        return _createElementVNode("div", {
          class: "team-card",
          key: member.name
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: member.image,
              alt: member.name
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(member.name), 1),
            _createElementVNode("p", null, _toDisplayString(member.role), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: member.git,
                target: "_blank",
                rel: "noreferrer"
              }, [
                _createVNode(_component_IconifyIcon, {
                  icon: "mdi:github",
                  width: "24",
                  height: "24"
                })
              ], 8, _hoisted_8),
              _createElementVNode("a", {
                href: member.linked,
                target: "_blank",
                rel: "noreferrer"
              }, [
                _createVNode(_component_IconifyIcon, {
                  icon: "mdi:linkedin",
                  width: "24",
                  height: "24"
                })
              ], 8, _hoisted_9)
            ])
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})